export type JourneyAudioType = 'bridge' | 'response' | 'step';

/**
 * Choice clips (`response`) are what move a question forward. Bridge and step
 * audio can fail without trapping the member on the page.
 */
export function shouldAdvanceAfterAudioFailure(
  type: JourneyAudioType | undefined
): boolean {
  return type === 'response';
}
